import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import AnimatedLogo from './AnimatedLogo';
import SocialLinks from './footer/SocialLinks';
import QuickLinks from './footer/QuickLinks';
import ContactInfo from './footer/ContactInfo';
import FooterServices from './footer/FooterServices';
import FooterBottomBar from './footer/FooterBottomBar';
import { useSectionNavigator } from '../hooks/useSectionNavigator';

const Footer = () => {
  const { t } = useLanguage();
  const scrollToSection = useSectionNavigator();

  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-t border-white/10">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[linear-gradient(30deg,#1e40af_12%,transparent_12.5%,transparent_87%,#1e40af_87.5%,#1e40af),linear-gradient(150deg,#1e40af_12%,transparent_12.5%,transparent_87%,#1e40af_87.5%,#1e40af)] bg-[length:80px_140px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div data-testid="footer-animated-logo">
              <AnimatedLogo />
            </div>
            <p className="text-gray-400 text-sm">
              {t.footer?.description}
            </p>
            <SocialLinks />
          </div>

          {/* Quick Links */}
          <QuickLinks scrollToSection={scrollToSection} />

          {/* Services */}
          <FooterServices />

          {/* Contact */}
          <ContactInfo />
        </div>

        {/* Bottom Bar */}
        <FooterBottomBar />
      </div>
    </footer>
  );
};

export default Footer;
